module.exports = __webpack_public_path__ + "img/564.06abc6ba.jpg";